<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { authHeader } from "../../../helpers/auth-header";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import InputGroup from "@/components/forms/input-group";
import SelectGroup from "@/components/forms/select-group";
import SaveButton from "@/components/buttons/save-button";

/**
 * Orders Component
 */
export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,

        InputGroup,
        SelectGroup,
        SaveButton
    },
    data() {
        const id = this.$route.params.id;
        const modeName = id === 'add' ? 'Add' : 'Edit';

        return {
            id: id,
            title: `Branch ${modeName}`,
            modeName,
            items: [
                {
                    text: "Branch"
                },
                {
                    text: modeName,
                    active: true,
                },
            ],

            tabs: ['info', 'timeslot'],

            data: {
                name: '',
                address: '',
                phone: '',
                status: 1,
                calendar_id: '',
                // mon_open: false,
                mon_am_start: null,
                mon_am_end: null,
                mon_pm_start: null,
                mon_pm_end: null,
                // tue_open: false,
                tue_am_start: null,
                tue_am_end: null,
                tue_pm_start: null,
                tue_pm_end: null,
                // wed_open: false,
                wed_am_start: null,
                wed_am_end: null,
                wed_pm_start: null,
                wed_pm_end: null,
                // thu_open: false,
                thu_am_start: null,
                thu_am_end: null,
                thu_pm_start: null,
                thu_pm_end: null,
                // fri_open: false,
                fri_am_start: null,
                fri_am_end: null,
                fri_pm_start: null,
                fri_pm_end: null,
                // sat_open: false,
                sat_am_start: null,
                sat_am_end: null,
                sat_pm_start: null,
                sat_pm_end: null,
                // sun_open: false,
                sun_am_start: null,
                sun_am_end: null,
                sun_pm_start: null,
                sun_pm_end: null,
                timeslotCategories: [],
            },
            statusOptions: [
                { name: 'Active', value: 1 },
                { name: 'Inactive', value: 0 },
            ],

            errors: {},
        };
    },
    watch: {
    },
    
    async mounted() {
        this.retrieveTimeslotCategories().then((timeslot_categories) => {
            if (this.modeName !== 'Add') {
                this.data.timeslotCategories = timeslot_categories.map((timeslot_category) => ({
                    id: timeslot_category.timeslot_category_id,
                    name: timeslot_category.name,
                    max_slot: timeslot_category.max_slot,
                }));
            } else {
                this.data.timeslotCategories = timeslot_categories.map((timeslot_category) => ({
                    id: timeslot_category.id,
                    name: timeslot_category.name,
                    max_slot: 0
                }));
            }
        });

        if (this.modeName !== 'Add') {
            const result = await axios.get(`${process.env.VUE_APP_APIURL}/branch/${this.id}`, {
                headers: authHeader(),
            });
            if (result && result.data['code'] === 'success') { 
                const data = result.data['data']['branch'];
                for (const [key, item] of Object.entries(data)) {
                    if (key in this.data) {
                        this.data[key] = item;
                    }
                }

                const branch_hour_data = result.data['data']['branch_hours'][0] ?? {};
                for (const [key, item] of Object.entries(branch_hour_data)) {
                    if (key in this.data) {
                        this.data[key] = item;
                    }
                }

                const branch_timeslot_data = result.data['data']['branch_timeslots'];
                for (const item of branch_timeslot_data) {
                    if (this.id == item.branch_id) {
                        for (const [key, value] of Object.entries(item)) {
                            this.data.timeslotCategories[key] = value;
                        }
                    }
                }
            }
        }
    },
    methods: {
        async retrieveTimeslotCategories() {
            this.loading = true;
            let timeslot_categories = [];

            if (this.modeName !== 'Add') {
                try {
                    const item = await axios.get(`${process.env.VUE_APP_APIURL}/branch-timeslot-category/${this.id}`, {
                        headers: authHeader(),
                    });

                    const result = await item.data;

                    if (result['code'] === 'success') {
                        timeslot_categories = result['data']['branch_timeslots'];
                    }
                } catch (e) {
                    console.error(e);
                }
            } else {
                try {
                    const item = await axios.get(`${process.env.VUE_APP_APIURL}/timeslot-category`, {
                        headers: authHeader(),
                    });

                    const result = await item.data;

                    if (result['code'] === 'success') {
                        timeslot_categories = result['data'].timeslot_categories;
                    }
                } catch (e) {
                    console.error(e);
                }
            }
            
            this.loading = false;
            return timeslot_categories;
        },

        async save() {
            this.errors = {};

            let result;
            if (this.modeName === 'Add') {
                const requestData = this.data;
                result = await axios.post(`${process.env.VUE_APP_APIURL}/branch`, requestData, {
                    headers: authHeader(),
                });
            } else {
                const filteredPairs = Object.entries(this.data);
                const requestData = Object.fromEntries(filteredPairs);
                result = await axios.put(`${process.env.VUE_APP_APIURL}/branch/${this.id}`, requestData, {
                    headers: authHeader(),
                });
            }

            if (result) {
                if (result.data['code'] === 'success') {
                    if (this.modeName === 'Add') {
                        this.$router.back();
                    } else {
                        this.$refs.messageModal.showModal('Your record has been updated successfully');
                    }
                } else if (result.data['code'] === 'invalid_field') {
                    this.errors = result.data['errors'];
                }
            }
        },
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body p-3">
                        <b-tabs content-class="mt-3">
                            <b-tab title="Info" active>
                                <div class="row">
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <InputGroup type="text" id="branch_name" displayName="Name*" v-model="data.name" :error="errors.name" />
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <InputGroup type="text" id="phone" displayName="Phone Number" v-model="data.phone" :error="errors.phone" />
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <SelectGroup id="status" displayName="Status*" v-model="data.status" :error="errors.status" :options="statusOptions" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <InputGroup type="textarea" id="address" displayName="Address" v-model="data.address" :error="errors.address" />
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4">
                                        <InputGroup type="text" id="calendar_id" displayName="Lark Calendar ID" v-model="data.calendar_id" :error="errors.calendar_id" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <p class="m-0">Operating Hour*</p>
                                        <div>
                                            <p class="font-weight-bold mt-3 mb-0"><strong>Monday:</strong></p>
                                            <div class="time w-100 d-inline-block">
                                                AM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="mon_am_start" id="mon_am_start" v-model="data.mon_am_start" :error="errors.mon_am_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="mon_am_end" id="mon_am_end" v-model="data.mon_am_end" :error="errors.mon_am_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.mon_am_start && errors.mon_am_start.length > 0">
                                                    {{ errors.mon_am_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.mon_am_end && errors.mon_am_end.length > 0">
                                                    {{ errors.mon_am_end[0] }}
                                                </div>
                                            </div>
                                            <div class="time w-100 d-inline-block">
                                                PM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="mon_pm_start" id="mon_pm_start" v-model="data.mon_pm_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="mon_pm_end" id="mon_pm_end" v-model="data.mon_pm_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.mon_pm_start && errors.mon_pm_start.length > 0">
                                                    {{ errors.mon_pm_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.mon_pm_end && errors.mon_pm_end.length > 0">
                                                    {{ errors.mon_pm_end[0] }}
                                                </div>
                                            </div>

                                            <p class="font-weight-bold mt-3 mb-0">Tuesday:</p>
                                            <div class="time w-100 d-inline-block">
                                                AM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="tue_am_start" id="tue_am_start" v-model="data.tue_am_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="tue_am_end" id="tue_am_end" v-model="data.tue_am_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.tue_am_start && errors.tue_am_start.length > 0">
                                                    {{ errors.tue_am_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.tue_am_end && errors.tue_am_end.length > 0">
                                                    {{ errors.tue_am_end[0] }}
                                                </div>
                                            </div>
                                            <div class="time w-100 d-inline-block">
                                                PM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="tue_pm_start" id="tue_pm_start" v-model="data.tue_pm_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="tue_pm_end" id="tue_pm_end" v-model="data.tue_pm_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.tue_pm_start && errors.tue_pm_start.length > 0">
                                                    {{ errors.tue_pm_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.tue_pm_end && errors.tue_pm_end.length > 0">
                                                    {{ errors.tue_pm_end[0] }}
                                                </div>
                                            </div>

                                            <p class="font-weight-bold mt-3 mb-0">Wednesday:</p>
                                            <div class="time w-100 d-inline-block">
                                                AM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="wed_am_start" id="wed_am_start" v-model="data.wed_am_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="wed_am_end" id="wed_am_end" v-model="data.wed_am_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.wed_am_start && errors.wed_am_start.length > 0">
                                                    {{ errors.wed_am_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.wed_am_end && errors.wed_am_end.length > 0">
                                                    {{ errors.wed_am_end[0] }}
                                                </div>
                                            </div>
                                            <div class="time w-100 d-inline-block">
                                                PM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="wed_pm_start" id="wed_pm_start" v-model="data.wed_pm_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="wed_pm_end" id="wed_pm_end" v-model="data.wed_pm_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.wed_pm_start && errors.wed_pm_start.length > 0">
                                                    {{ errors.wed_pm_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.wed_pm_end && errors.wed_pm_end.length > 0">
                                                    {{ errors.wed_pm_end[0] }}
                                                </div>
                                            </div>

                                            <p class="font-weight-bold mt-3 mb-0">Thursday:</p>
                                            <div class="time w-100 d-inline-block">
                                                AM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="thu_am_start" id="thu_am_start" v-model="data.thu_am_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="thu_am_end" id="thu_am_end" v-model="data.thu_am_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.thu_am_start && errors.thu_am_start.length > 0">
                                                    {{ errors.thu_am_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.thu_am_end && errors.thu_am_end.length > 0">
                                                    {{ errors.thu_am_end[0] }}
                                                </div>
                                            </div>
                                            <div class="time w-100 d-inline-block">
                                                PM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="thu_pm_start" id="thu_pm_start" v-model="data.thu_pm_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="thu_pm_end" id="thu_pm_end" v-model="data.thu_pm_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.thu_pm_start && errors.thu_pm_start.length > 0">
                                                    {{ errors.thu_pm_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.thu_pm_end && errors.thu_pm_end.length > 0">
                                                    {{ errors.thu_pm_end[0] }}
                                                </div>
                                            </div>

                                            <p class="font-weight-bold mt-3 mb-0">Friday:</p>
                                            <div class="time w-100 d-inline-block">
                                                AM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="fri_am_start" id="fri_am_start" v-model="data.fri_am_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="fri_am_end" id="fri_am_end" v-model="data.fri_am_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.fri_am_start && errors.fri_am_start.length > 0">
                                                    {{ errors.fri_am_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.fri_am_end && errors.fri_am_end.length > 0">
                                                    {{ errors.fri_am_end[0] }}
                                                </div>
                                            </div>
                                            <div class="time w-100 d-inline-block">
                                                PM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="fri_pm_start" id="fri_pm_start" v-model="data.fri_pm_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="fri_pm_end" id="fri_pm_end" v-model="data.fri_pm_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.fri_pm_start && errors.fri_pm_start.length > 0">
                                                    {{ errors.fri_pm_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.fri_pm_end && errors.fri_pm_end.length > 0">
                                                    {{ errors.fri_pm_end[0] }}
                                                </div>
                                            </div>

                                            <p class="font-weight-bold mt-3 mb-0">Saturday:</p>
                                            <div class="time w-100 d-inline-block">
                                                AM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="sat_am_start" id="sat_am_start" v-model="data.sat_am_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="sat_am_end" id="sat_am_end" v-model="data.sat_am_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.sat_am_start && errors.sat_am_start.length > 0">
                                                    {{ errors.sat_am_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.sat_am_end && errors.sat_am_end.length > 0">
                                                    {{ errors.sat_am_end[0] }}
                                                </div>
                                            </div>
                                            <div class="time w-100 d-inline-block">
                                                PM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="sat_pm_start" id="sat_pm_start" v-model="data.sat_pm_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="sat_pm_end" id="sat_pm_end" v-model="data.sat_pm_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.sat_pm_start && errors.sat_pm_start.length > 0">
                                                    {{ errors.sat_pm_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.sat_pm_end && errors.sat_pm_end.length > 0">
                                                    {{ errors.sat_pm_end[0] }}
                                                </div>
                                            </div>

                                            <p class="font-weight-bold mt-3 mb-0">Sunday:</p>
                                            <div class="time w-100 d-inline-block">
                                                AM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="sun_am_start" id="sun_am_start" v-model="data.sun_am_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="sun_am_end" id="sun_am_end" v-model="data.sun_am_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.sun_am_start && errors.sun_am_start.length > 0">
                                                    {{ errors.sun_am_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.sun_am_end && errors.sun_am_end.length > 0">
                                                    {{ errors.sun_am_end[0] }}
                                                </div>
                                            </div>
                                            <div class="time w-100 d-inline-block">
                                                PM From
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="sun_pm_start" id="sun_pm_start" v-model="data.sun_pm_start" />
                                                To
                                                <input type="time" class="form-control m-2 w-25 d-block d-md-inline-block operating-hour" name="sun_pm_end" id="sun_pm_end" v-model="data.sun_pm_end" />
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.sun_pm_start && errors.sun_pm_start.length > 0">
                                                    {{ errors.sun_pm_start[0] }}
                                                </div>
                                                <div class="alert alert-danger mt-3" role="alert" v-if="errors.sun_pm_end && errors.sun_pm_end.length > 0">
                                                    {{ errors.sun_pm_end[0] }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Timeslots">
                                <div v-if="data.timeslotCategories && data.timeslotCategories.length > 0">
                                    <div class="row" v-for="(category, index) in data.timeslotCategories" :key="'timeslot_cat_' + category.id">
                                        <div class="col-6 col-md-3">
                                            <label v-if="index === 0" :for="`timeslot_cat_${category.id}`">Timeslot Category</label>
                                            <input type="text" disabled class="form-control mb-2" :id="`timeslot_cat_${category.id}`" v-model="data.timeslotCategories[index].name" style="background-color: lightgray;" />
                                        </div>
                                        <div class="col-6 col-md-3">
                                            <label v-if="index === 0" :for="`max_slot_${category.id}`">Maximum Slot</label>
                                            <input type="text" class="form-control mb-2" :id="`max_slot_${category.id}`" v-model="data.timeslotCategories[index].max_slot" />
                                            <div class="alert alert-danger mt-3" role="alert" v-if="errors['timeslotCategories.' + index + '.max_slot'] && errors['timeslotCategories.' + index + '.max_slot'].length > 0">
                                                {{ errors['timeslotCategories.' + index + '.max_slot'][0] }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p v-else>There are no timeslot category, please add one.</p>
                            </b-tab>
                        </b-tabs>

                        <div class="row mt-5">
                            <div class="col-12">
                                <SaveButton @click="save" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>